<template>  
<div> <!-- root element start -->

    <div  class="row">
      <div v-if="loading == 0" class="col-12 mt-4">
        <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
      </div>
    </div>

    <div v-if="loading == 1" class="row">

      

      <div class="col-12">
          <div class="card border-0">
            <div class="card-header h5 bg-transparent border-0">Single Invite</div>
            <div class="card-body">

              <div class="row"><!--  command row -->
                <div class="col-12">
                  <button @click="resendInvitation" class="btn btn-primary">Resend Invitation</button>
                  <button @click="deleteInvite" class="btn btn-danger">Delete Invitation</button>
                </div>
              </div>
              
              <hr class="bg-dark">

              <div class="row h-100 justify-content-center align-self-center"><!--  if user, sales manager row -->
                <div class="col-md-2">
                  <span class="h6 font-weight-bold ">Invitor</span>
                </div>
                <div class="col-md-8"><div>{{ invitor }}</div></div>
                <div class="col-md-2"></div>
              </div>

              <hr class="bg-dark">

              <div class="row"><!--  email row -->
                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Email</span>
                </div>
                <div class="col-md-4"><div>{{ email }}</div></div>
                <div class="col-md-4"></div>
                <div class="col-md-2"></div>
              </div>

              <hr class="bg-dark">

              <div class="row h-100 justify-content-center align-self-center"><!--  role row -->
                <div class="col-md-2">
                  <span class="h6 font-weight-bold ">Role</span>
                </div>
                <div class="col-md-4"> <div>{{ role }}</div></div>
                <div class="col-md-4">
                </div>
                <div class="col-md-2">
                </div>
              </div>

              <hr class="bg-dark">

              <div v-if="roleNum == 0" class="row h-100 justify-content-center align-self-center"><!--  if user, sales manager row -->
                <div class="col-md-2 ">
                  <span class="h6 font-weight-bold ">Manager</span>
                </div>
                <div class="col-md-8"><div>{{ manager }}</div></div>
                <div class="col-md-2"></div>
              </div>

              <hr v-if="roleNum == 0" class="bg-dark">

              <div class="row h-100 justify-content-center align-self-center"><!--  if user, sales manager row -->
                <div class="col-md-2 ">
                  <span class="h6 font-weight-bold ">Created</span>
                </div>
                <div class="col-md-8"><div>{{ startDate }} ({{ diff }} days ago)</div></div>
                <div class="col-md-2"></div>
              </div>


            </div>
          </div>
      </div>
    </div>


</div> <!-- root element end -->
</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/admin-user-store.js'


// import catMain from '../InstComponents/CategoryComponents/category-main.vue'


export default {
  store,
  data: function () {
    return { 
      loading: 0,
      email: '',
      role: '',
      manager: '',
      invitor: '',
      startDate: '',
      diff: '',
    }
  },
  computed: {
    prop1 () { return this.$store.state.prop1 },
  },
  watch: {
    
  },
  mounted() {
    this.getInviteInfo(this.prop1);
  },
  methods: {
    changeRightView(name, prop1, prop2) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2 }); },
    getAllInvites() { this.$store.dispatch("getAllInvites"); },
    
    getInviteInfo(x) {
      var _this = this;
      _this.loading = 0;
      axios.get('/admin/utility/getsingleinvites/' + x)
        .then(function (response) {
        var a = response.data.data;
        console.log(a)
        if(a == null || a == ''){ var b = []; } else { var b = a; }
        _this.email = b.email;
        _this.role = b.role;
        _this.roleNum = b.roleNum;
        _this.manager = b.manager;
        _this.invitor = b.invitor;
        _this.startDate = b.created_at;
        _this.diff = b.diff;
        _this.loading = 1;
      });
    },
    resendInvitation() {
      var _this = this;
      _this.$toastr.warning('Resending invitation email.', 'Please wait!')
      var x = _this.prop1
      axios.get('/admin/utility/resendinvitation/' + x)
        .then(function (response) {
          var msg = response.data.msg;
          _this.$toastr.remove()
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.passRestButton = false;
        })
        .catch(function (error) {
          var errors = error.response.data.errors;
          var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
          $.each(errors, function(key, value){ errorsHTML += '<li>' + value[0] + '</li>' });
          errorsHTML += '</ul></div>';
          _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
        })
    },
    deleteInvite() {
      var _this = this;
      _this.$swal({
        title: 'Are you sure?',
        text: "Are you sure? The email previously sent will no longer work to register the user.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          _this.$toastr.error('Deleting Invitation.', 'Please wait!')
          var x = _this.prop1;
          axios.get('/admin/utility/deleteinvitation/' + x)
            .then(function (response) {
              var msg = response.data.msg;
              _this.$toastr.remove()
              _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
              _this.getAllInvites()
              _this.changeRightView('invite-list','','');
            })
            .catch(function (error) {
              _this.$toastr.remove()
              var errors = error.response.data.errors;
              var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
              $.each(errors, function(key, value){ errorsHTML += '<li>' + value[0] + '</li>' });
              errorsHTML += '</ul></div>';
              _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
            })
        }
      })
    }
  },    
  components:{
    ScalingSquaresSpinner
  },
  filters: {

  }
}
</script>
